import React from 'react';
import { getTierDisplayNameSync } from '../../utils/tierUtils';

const TournamentPlayers = ({ players }) => {
  return (
    <div className="proskins-card" style={{
      padding: 'var(--spacing-lg)',
      background: 'var(--bg-card)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-md)',
      border: '1px solid var(--border-primary)'
    }}>
      <h3 className="proskins-card-title" style={{ 
        marginBottom: 'var(--spacing-lg)',
        color: 'var(--text-primary)',
        fontSize: 'var(--font-size-2xl)',
        fontWeight: '600'
      }}>
        Golfers ({players.length})
      </h3>
      {players.length === 0 ? (
        <div className="proskins-text-center proskins-text-muted" style={{ padding: 'var(--spacing-2xl)' }}>
          No golfers registered yet
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 'var(--spacing-md)'
        }}>
          {players.map((player) => (
            <div key={player.id} style={{
              padding: 'var(--spacing-md)',
              border: '1px solid var(--border-primary)',
              borderRadius: 'var(--radius-lg)',
              backgroundColor: 'var(--bg-tertiary)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{
                    fontWeight: 'bold',
                    fontSize: 'var(--font-size-lg)',
                    color: 'var(--text-primary)',
                    marginBottom: 'var(--spacing-xs)'
                  }}>
                    {player.golfer.name}
                  </div>
                  <div style={{
                    color: 'var(--text-secondary)',
                    fontSize: 'var(--font-size-sm)',
                    marginBottom: 'var(--spacing-xs)'
                  }}>
                    Ranking: #{player.golfer.worldRanking || 'N/A'} | Tier: {getTierDisplayNameSync(player.tier || player.golfer.tier)}
                  </div>
                  <div style={{
                    color: 'var(--text-secondary)',
                    fontSize: 'var(--font-size-sm)'
                  }}>
                    {player.golfer.country}
                  </div>
                </div>
                <div style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: player.golfer.isActive ? 'var(--success)' : 'var(--error)',
                  marginLeft: 'var(--spacing-sm)'
                }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TournamentPlayers;